import React from 'react';
import $ from 'jquery';

//elegant form validation
import TextView from '../../elegant_form_validation/Util/TextView.js';
import update from 'immutability-helper';
import { run, ruleRunner } from '../../elegant_form_validation/Validation/ruleRunner.js'
import { required, minLength } from '../../elegant_form_validation/Validation/rules.js';
//<-

import Row from '../ui/Row';
import Col from '../ui/Col';

import RestClient from '../rest/RestClient';
import MicroEvent  from '../other/microevent';
import Container from 'react-bootstrap/esm/Container.js';

//import md5 from 'js-md5';


const fieldValidations = [
  ruleRunner("emailAddress", "Email Address", required),
];


export default class ForgotPass extends React.Component {

  state = {
    redirectToReferrer: false,
    submitStarted:false,
    submitFailed: false,
    submitSucceeded: false,
  }

  constructor(props) {
    super(props);

    MicroEvent.mixin(ForgotPass);

    this.handleFieldChanged = this.handleFieldChanged.bind(this);
    this.errorFor = this.errorFor.bind(this);
    this.state = {
      showErrors:                         false,
      validationErrors:                   { },
      restError:                          null,
      secondsLeftToNewAccountRedirection: 4
    }
  }

  componentWillMount() {
    // Run validations on initial state
    this.setState({validationErrors: run(this.state, fieldValidations)});
  }

  errorFor(field) {
    return this.state.validationErrors[field] || "";
  }

  handleFieldChanged(field) {
    return (e) => {
      // update() is provided by React Immutability Helpers
      // https://facebook.github.io/react/docs/update.html
      let newState = update(this.state, {
        [field]: {$set: e.target.value}
      });
      newState.validationErrors = run(newState, fieldValidations);
      this.setState(newState);
    };
  }

  submit = () => {
    this.setState({showErrors: true});
    if($.isEmptyObject(this.state.validationErrors) === false) return null;

    if (this.state.pass2!==this.state.pass3){
      var validationErrors = this.state.validationErrors;
      validationErrors['pass3'] = 'Password mismatch';
      this.setState({validationErrors:validationErrors});
      return;
    }

    this.setState({ submitStarted: true });
    this.setState({ submitFailed: false });
    this.setState({ submitSucceeded: false });

    RestClient.forgotPass(this.state.emailAddress, () => {
      this.setState({ submitSucceeded: true });
      this.setState({ submitStarted: false });
      this.setState({ submitFailed: false });

    },
    (error) => {
      this.setState({ restError: error});
      this.setState({ submitStarted: false });
      this.setState({ submitFailed: true });
    })
  }

  countdownOfRedirectionToNewAccount(){
    var secondsLeft = (this.state.secondsLeftToNewAccountRedirection - 1);
    console.log('countdownOfRedirectionToNewAccount:' + secondsLeft);
    this.setState({secondsLeftToNewAccountRedirection:secondsLeft});

    if (secondsLeft === 0) {
      clearInterval(this.state.refreshIntervalId);
    }
  }

  render() {
    if (this.state.submitSucceeded) { //it is flag of success indeed
      return (
        <div className="login-page">
          <Container align="center">
            <Row>
              <p>The confirmation message has been sent to your contact email.</p>
            </Row>
            <Row>
              <p>Please read and follow instructions to finish the recovery!</p>
            </Row>
          </Container>
        </div>
      )
    }

    var authMessage0 = 'Please enter your login email to recover your password';

    var authMessage1 = (this.state.submitStarted)
        ? (<div class="waiting">Initiating recovery<br/></div>):'';

    var authMessage2 = (this.state.submitFailed)
        ? (<p class="text-red">Change password attempt failed: <i>{this.state.restError.message}</i></p>):'';

    return (
      <div className="login-page">
        <Container align="center">
          <Row>
            <Col>
              <p>{authMessage0}</p>
              <p>{authMessage1}</p>
              <p>{authMessage2}</p>
            </Col>
          </Row>
          <Row>
            <TextView placeholder="Email Address" showError={this.state.showErrors}
                  text={this.props.emailAddress} onFieldChanged={this.handleFieldChanged("emailAddress")}
                verticalWithError="true"
                errorText={this.errorFor("emailAddress")} />
            </Row>
          <Row>
            <button type='submit' id="green" className="sc-btn sc-btn-red sc-btn-big" onClick={this.submit}>Recover</button>
          </Row>
        </Container>
      </div>
    )
  }
}
